import { useData } from "../contexts/DataContext";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import TaskFormFields from "./TaskFormFields";
import { useTaskDialogForm } from "./useTaskDialogForm";

function dialogTitle(task, parentId) {
  if (task) return "Edit task";
  if (parentId) return "New subtask";
  return "New task";
}

function submitLabel(saving, task) {
  if (saving) return "Saving…";
  if (task) return "Save changes";
  return "Create";
}

export default function TaskDialog({ open, onClose, projectId, parentId = null, task = null, defaultStatus = "todo", defaultDueDate = null, projects = null }) {
  const { users } = useData();
  const form = useTaskDialogForm({ open, task, parentId, defaultStatus, defaultDueDate, projectId, onClose });

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="task-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">{dialogTitle(task, parentId)}</DialogTitle>
          <DialogDescription className="sr-only">Create or edit a task with status, priority, dates and assignees</DialogDescription>
        </DialogHeader>
        <form onSubmit={form.submit} className="space-y-3">
          {projects && !task && !parentId && (
            <Select value={form.selProject} onValueChange={form.setSelProject}>
              <SelectTrigger data-testid="task-project-select" className="h-8 text-sm"><SelectValue placeholder="Select project" /></SelectTrigger>
              <SelectContent>
                {projects.map((p) => <SelectItem key={p.id} value={p.id} data-testid={`project-option-${p.id}`}>{p.name}</SelectItem>)}
              </SelectContent>
            </Select>
          )}
          <input autoFocus data-testid="task-title-input" value={form.title} onChange={(e) => form.setTitle(e.target.value)} placeholder="Task title"
            className="w-full h-9 px-3 text-sm rounded-md border border-border bg-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary" />
          <textarea data-testid="task-description-input" value={form.description} onChange={(e) => form.setDescription(e.target.value)} placeholder="Description (optional)" rows={3}
            className="w-full px-3 py-2 text-sm rounded-md border border-border bg-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary resize-none" />
          <TaskFormFields status={form.status} onStatus={form.setStatus} priority={form.priority} onPriority={form.setPriority}
            startDate={form.startDate} onStartDate={form.setStartDate} dueDate={form.dueDate} onDueDate={form.setDueDate}
            dueTime={form.dueTime} onDueTime={form.setDueTime}
            users={users} assignees={form.assignees} onToggleAssignee={form.toggleAssignee} />
          <div className="flex justify-end gap-2 pt-1">
            <button type="button" data-testid="task-cancel" onClick={onClose} className="h-8 px-3 text-sm rounded-md border border-border hover:bg-muted transition-colors">Cancel</button>
            <button type="submit" data-testid="task-submit" disabled={form.saving} className="h-8 px-4 text-sm rounded-md bg-[#E31E24] hover:bg-[#C81A1F] text-white font-medium transition-colors disabled:opacity-60">
              {submitLabel(form.saving, task)}
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
